import { ErrorHandler, inject, Injectable } from '@angular/core';
import { LoggerService } from '~ngx-shared/services';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  private readonly loggerService = inject(LoggerService);

  handleError(error: any): void {
    console.error('An error occurred:', error);
    this.loggerService.error(describeError(error), error?.stack);
  }
}

// JSON.stringify(new Error()) is '{}' - Error properties are not enumerable.
export function describeError(error: any): string {
  if (!error) {
    return 'Unknown error';
  }
  if (error.message) {
    return error.name ? `${error.name}: ${error.message}` : String(error.message);
  }
  if (typeof error === 'string') {
    return error;
  }
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
}
